export interface CommunityUser {
  id: string;
  name: string | null;
  email: string;
  joined_at: string;
  blocked: boolean;
  community_role: string;
  user_roles: string[];
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  REMOVED = 'REMOVED',
}

export interface CommunityUsersResponse {
  total_items: number;
  current_page: number;
  total_pages: number;
  page_limit: number;
  data: CommunityUser[];
}

export interface CommunityUsersQueryParams {
  page?: number;
  limit?: number;
  search?: string;
  community_id?: string;
}

export interface RemoveUserPayload {
  community_id: string;
  user_id: string;
}

export type UserAction = 'BLOCK' | 'UNBLOCK' | 'DELETE';

export interface UpdateUserStatusPayload {
  community_id: string;
  user_id: string;
  action: UserAction;
}

export enum CommunityRole {
  READER = 'READER',
  CONTRIBUTOR = 'CONTRIBUTOR',
  MODERATOR = 'MODERATOR',
  COMMUNITY_ADMIN = 'COMMUNITY ADMIN',
}

export interface UpdateUserRolePayload {
  community_id: string;
  user_id: string;
  role: CommunityRole;
}

export interface EligibleCommunityUser {
  id: string;
  name: string | null;
  email: string;
  profile_picture: string | null;
}

export type CommunityInvitationStatus =
  | 'active'
  | 'expired'
  | 'cancelled'
  | 'completed';

export interface CommunityInvitation {
  id: string;
  community_id: string;
  email: string;
  status: CommunityInvitationStatus;
  role: CommunityRole;
  expires_at: string;
  used_at: string | null;
  created_at: string;
}

export type CommunityInvitationPortal = 'admin' | 'frontend';

export interface CommunityInvitationResolution {
  id: string;
  community_id: string;
  community_name: string;
  email: string;
  status: CommunityInvitationStatus;
  role: CommunityRole;
  expires_at: string;
  portal: CommunityInvitationPortal;
  redirect_url: string;
  existing_user: boolean;
  is_admin_panel_user: boolean;
}

export interface CommunityInvitationsResponse {
  total_items: number;
  current_page: number;
  total_pages: number;
  page_limit: number;
  data: CommunityInvitation[];
}

export interface CommunityInvitationsQueryParams {
  community_id: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: CommunityInvitationStatus;
}

export interface AddCommunityUserPayload {
  community_id: string;
  user_id: string;
  role: CommunityRole;
}

export interface CreateCommunityInvitationPayload {
  community_id: string;
  email: string;
  role: CommunityRole;
  expires_at?: string;
}
